
















import Vue from 'vue'
// @ts-ignore
import MaskedInput from '../DynamicInput/src/MaskedInput'

export default Vue.extend({
  name: 'PhoneInput',
  components: {MaskedInput},
  props: {
    name: {},
    value: String,
    placeholder: {},
    readOnly: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
  },
  methods: {
    onBlur (event: UIEvent) {
      this.$emit('blur', event)
    },
    onInput (event: string) {
      this.$emit('input', event)
    }
  },
  computed: {
    currentValue: {
      get (): string {
        return this.value as string
      },
      set () {
      }
    }
  }
})
